<div class="content dark">
	<div class="row">
		<div class="col-lg-4">
			<div *ngIf="regimeCounts" class="row">
				<div class="col-12">
					<div class="item-panel">
						<div class="heading">Regimes</div>
						<div class="content">
							<table class="table regimes">
								<tr>
									<th># Acq</th>
									<th>Regime</th>
									<th>Evaluate</th>
								</tr>
								<tr *ngFor="let regime of regimeCounts">
									<td>{{regime.count}}</td>
									<td>{{regime.name}}</td>
									<td class="center">
										<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()">
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div><!-- End left column -->
		<div class="col-lg-8">
			<div class="item-panel">
				<div class="heading">Track Split</div>
				<div class="content">
					<app-dvs-chart [options]="timelineOptions" [light]="true" [height]="'300px'" [error]="(regimeCounts && regimeCounts.length === 0) ? 'No track data found' : undefined" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
					<div *ngIf="timelineOptions && adjustments && adjustments.length" class="legend">
						<span class="legend-item">
							<span class="swatch" style="background-color: #f3f700"></span> Adjustment (see below)
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Adjustment History</div>
				<div class="content">
					<div *ngIf="adjustments && !adjustments.length">
						No adjustments have been recorded for this rotor
					</div>
					<div *ngIf="adjustments && adjustments.length" class="adjustment-list">
						<p>Rotor blades: {{blades}}</p>
						<table>
							<tr>
								<th>Operation</th>
								<th>Entered by</th>
								<th *ngFor="let adjdef of rotor.adjdef">{{adjdef.name}}</th>
								<th>User note</th>
								<th *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									Delete</th>
							</tr>
							<tr *ngFor="let adjustment of adjustments">
								<td>{{adjustment.operation_start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}</td>
								<td>{{adjustment.author_email}}</td>
								<td *ngFor="let row of adjustment.adjustments.split('|')">{{row | commalist}}</td>
								<td class="truncate" [title]="adjustment.user_note"><span>{{adjustment.user_note}}</span></td>
								<td *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									<app-action-button [action]="DeleteAdjustment" [args]="[adjustment.adjustment_history_id]"
										[context]="this" btnClass="btn-danger btn-sm" confirm="Are you sure?" processing="...">x
									</app-action-button>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>